import { Session } from './state/session';
import { KpvUi } from './ui/KpvUi';
import { MidiManager } from './midi/MidiManager';

const canvas = document.getElementById('renderCanvas') as HTMLCanvasElement;
const boot = document.getElementById('boot') as HTMLDivElement;
const powerBtn = document.getElementById('powerBtn') as HTMLButtonElement;

powerBtn.addEventListener('click', () => {
  void (async () => {
    powerBtn.disabled = true;
    powerBtn.textContent = 'BOOTING…';
    try {
      const session = new Session();
      await session.boot();
      const ui = new KpvUi(canvas, session);
      ui.ready();

      // MIDI targets deck 1 (hardware KPV CC map). Never blocks boot —
      // modern Chrome shows a permission prompt.
      const midi = new MidiManager(session.decks[0]!);
      void midi.init().then((ok) => {
        if (ok && midi.inputs.length) {
          console.info('[KPV] MIDI inputs:', midi.inputs.join(', '));
        }
      });

      // Drag & drop audio files → next free bank of the focused deck.
      window.addEventListener('dragover', (e) => e.preventDefault());
      window.addEventListener('drop', (e) => {
        e.preventDefault();
        const file = e.dataTransfer?.files[0];
        if (!file) return;
        const store = session.focused;
        const banks = Array.from({ length: store.visibleBanks }, (_, b) => b);
        const bank = banks.find((b) => store.bankState(b) === 0) ?? 0;
        void store.engine.loadSampleFile(bank, file).then(() => store.engine.sampleTrigger(bank, true));
      });

      // Debug/integration handle (console, automation, future scripting).
      (window as unknown as { kpv: unknown }).kpv = { session, ui, midi };
      console.info('[KPV] booted', {
        sampleRate: session.system.sampleRate,
        crossOriginIsolated,
        latencyMs: session.system.contextLatencyMs.toFixed(2),
        decks: session.decks.length,
      });

      boot.remove();
    } catch (err) {
      powerBtn.disabled = false;
      powerBtn.textContent = 'POWER ON';
      console.error('[KPV] boot failed', err);
      const msg = document.createElement('div');
      msg.className = 'sub';
      msg.style.color = '#ff4455';
      msg.textContent = `Boot failed: ${String(err)}`;
      boot.appendChild(msg);
    }
  })();
});
